import { RunwayResponse } from "awd-server-api";

export const emptyRunway: RunwayResponse = {
  id: -1,
};
